import React from "react";

const SITE_EMAIL = process.env.REACT_APP_EMAIL || "support@kademy.com";
const SITE_PHONE = process.env.REACT_APP_PHONE || "+91 99999 99999";

const RefundPolicy = () => {
  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heroTitle}>Refund Policy</h1>
        <p style={styles.heroSub}>
          Transparent, fair & student-first refund guidelines
        </p>
      </div>

      {/* Content */}
      <div style={styles.container}>
        <Section title="Overview">
         <p>
  At <strong>KADEMY</strong>, we believe in complete transparency and learner
  satisfaction. Our goal is to empower students with high-quality education
  while ensuring a fair and reliable purchasing experience. This Refund Policy
  explains the conditions under which refunds are provided and how they are
  processed.
</p>
        </Section>

        <Section title="Refund Eligibility">
          <ul>
  <li>
    Refund requests must be submitted within <b>7 days</b> from the date of
    purchase.
  </li>
  <li>
    The learner must not have completed more than <b>20%</b> of the course
    content.
  </li>
  <li>
    Refunds are applicable only to courses purchased directly through the
    KADEMY platform.
  </li>
</ul>

        </Section>

        <Section title="Non-Refundable Situations">
         <ul>
  <li>
    Courses that are substantially completed or accessed beyond the allowed
    refund limit
  </li>
  <li>
    Any course content that has been downloaded, shared, or misused
  </li>
  <li>
    Courses purchased under discounts, offers, or promotional campaigns
  </li>
  <li>
    Accounts found violating KADEMY’s terms, policies, or ethical usage
    guidelines
  </li>
</ul>

        </Section>

        <Section title="Refund Process">
          <p>
  To request a refund, learners must contact the KADEMY support team using their
  registered email address along with valid order details. Once the request is
  reviewed and approved, the refund will be processed securely within
  <b> 7–10 business days</b>.
</p>

        </Section>

        <Section title="Payment Method">
         <p>
  All approved refunds will be credited back to the original payment method
  used at the time of purchase. KADEMY does not issue refunds through
  alternative payment channels for security reasons.
</p>
 
        </Section>

        <Section title="Need Help?">
         <p>
  If you have any questions, concerns, or require further clarification
  regarding this policy, our support team is always here to help.
  <br /><br />
  📧 <b>{SITE_EMAIL}</b><br />
  📞 <b>{SITE_PHONE}</b>
</p>

        </Section>
      </div>
    </div>
  );
};

/* Reusable Section Component */
const Section = ({ title, children }) => (
  <div style={styles.section}>
    <h2 style={styles.sectionTitle}>{title}</h2>
    {children}
  </div>
);

/* Styles – Matches KADEMY Theme */
const styles = {
  page: {
    fontFamily: "Inter, sans-serif",
    backgroundColor: "#f8f9ff",
    minHeight: "100vh",
  },
  hero: {
    background: "linear-gradient(135deg, #4f46e5, #9333ea)",
    padding: "80px 20px",
    textAlign: "center",
    color: "#fff",
  },
  heroTitle: {
    fontSize: "42px",
    fontWeight: "700",
    marginBottom: "10px",
  },
  heroSub: {
    fontSize: "16px",
    opacity: 0.9,
  },
  container: {
    maxWidth: "900px",
    margin: "50px auto",
    padding: "40px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
  },
  section: {
    marginBottom: "32px",
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#4f46e5",
    marginBottom: "12px",
  },
};

export default RefundPolicy;
